import * as React from 'react';
import { BaseComponent } from './BaseComponent';

declare var grecaptcha: any;

export interface ReCAPTCHAProps extends React.Props<ReCAPTCHA> {
    sitekey: string;
    callback: (captchaToken?: string) => void;
}

export class ReCAPTCHA extends BaseComponent<ReCAPTCHAProps, {}> {
    protected recaptcha: HTMLDivElement;
    protected recaptchaWidgetId: number | null;

    public async execute(): Promise<void> {
        grecaptcha.execute(this.recaptchaWidgetId);
    }

    public callback(captchaToken?: string): void {
        this.props.callback(captchaToken);
    }

    public reset(): void {
        if (this.recaptchaWidgetId !== null) {
            grecaptcha.reset(this.recaptchaWidgetId);
            if (this.recaptcha === null) {
                this.recaptchaWidgetId = null;
            }
        }
    }

    public render(): JSX.Element {
        return (
            <div
                className="g-recaptcha"
                key="recaptcha"
                ref={this.handleRef}
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    margin: '30px 0'
                }}
            />
        );
    }

    protected handleRef = (node: HTMLDivElement): void => {
        this.recaptcha = node;
        if (node !== null) {
            this.recaptchaWidgetId = grecaptcha.render(node, {
                sitekey: this.props.sitekey,
                callback: this.callback.bind(this),
                'expired-callback': this.callback.bind(this),
                'error-callback': this.callback.bind(this),
                // size: 'invisible',
                badge: 'inline'
            });
        } else {
            this.reset();
        }
    };
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ReCAPTCHA.tsx